import { useEffect, useState, ChangeEvent } from 'react'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem
} from '@mui/material'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import TextField from '@mui/material/TextField'
import logo from '../../images/logo-wfgps.svg'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { signup } from '../../services/AuthService'
import { Role } from '../../services/Types'
import classNames from 'classnames'
import {
  flexItemCenter,
  flexItemColumn,
  loginSignupButton,
  loginSignupImageStyle
} from '../../global'
import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'
//import { useAuthState } from '../Auth/AuthProvider'
import { useMediaQuery } from '@mui/material'
import { ButtonCustom } from '../Button/ButtonCustom'
import { programOffice } from '../../services/EventService'
import SuccessSignupIcon from '../../images/SuccessSignupIcon.svg'

var isMobView = false

const useStyles = makeStyles({
  root: {
    '&.MuiFormControl-root': {
      margin: '10px',
      [appTheme.breakpoints.down('md')]: {
        margin: '15px 0'
      }
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: ' rgba(0, 0, 0, 0.2)'
      },
      '&:hover fieldset': {
        borderColor: '#006BD7'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#006BD7'
      }
    }
  },

  buttonDesing: {
    background: '#253D82',
    boxShadow: 'none',
    width: '270px !important',
    margin: '14px auto 0!important',
    display: 'flex',
    '&:hover': {
      background: '#253D82'
    }
  },
  heightVh_16px: {
    height: 'auto',
    [appTheme.breakpoints.up('md')]: {
      height: 'calc(100% - 20px)'
    }
  },
  inputBoxStyle: {
    width: '100%',
    display: 'block',
    [appTheme.breakpoints.up('md')]: {
      width: '560px',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    },
    '& .css-gre06o-MuiFormLabel-asterisk': {
      color: '#D50000 '
    }
  },
  inputStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    [appTheme.breakpoints.up('md')]: {
      width: '270px !important'
    }
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '8px'
      }
    }
  },

  boxWrapper: {
    padding: '15px',
    [appTheme.breakpoints.up('md')]: {
      padding: '0'
    }
  },
  closeIcon: {
    width: '100px',
    float: 'right',
    margin: '0.5rem',
    position: 'static',
    [appTheme.breakpoints.down('lg')]: {
      right: '1rem',
      margin: '0',
      position: 'absolute',
      top: '1rem'
    }
  }
})

interface signupProps {
  signupPage: boolean
  handleLoginOpen: any
  classList: any
  modelClose: any
}

const emailValidator = (email: string) => {
  if (email === '') {
    return 'Email is required'
  } else if (!new RegExp(/\S+@\S+\.\S+/).test(email)) {
    return 'Incorrect email format'
  }
  return ''
}

const passwordValidator = (password: string) => {
  if (!password || password === '') {
    return 'Password is required'
  }
  return ''
}

const firstNameValidator = (firstName: string) => {
  if (!firstName || firstName === '') {
    return 'First Name is required'
  }
  return ''
}

const lastNameValidator = (lastName: string) => {
  if (!lastName || lastName === '') {
    return 'Last Name is required'
  }
  return ''
}

const roleValidator = (role: string) => {
  if (!role || role === '') {
    return 'Role is required'
  }
  return ''
}

const programOfficeValidator = (programOffice: number) => {
  if (!programOffice) {
    return 'Program Office is required'
  }
  return ''
}

const Item = styled(Paper)(({ theme }) => ({}))

function Signup(props: signupProps) {
  const classes = useStyles()
  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))

  //const { updateAuthState } = useAuthState()
  const [signupState, setSignupState] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    role: '',
    programOffice: 0
  })
  const [programOfficeData, setProgramOfficeData] = useState<
    { id: number; title: string }[]
  >([])
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [firstNameError, setFirstNameError] = useState('')
  const [lastNameError, setLastNameError] = useState('')
  const [roleError, setRoleError] = useState('')
  const [programOfficeError, setProgramOfficeError] = useState('')
  const [showRequestReceived, setRequestReceived] = useState(false)

  useEffect(() => {
    const loadProgramOfficeData = async () => {
      try {
        const { data } = await programOffice()
        setProgramOfficeData(data.programOffice.data)
      } catch (error) {
        console.log(error)
      }
    }

    loadProgramOfficeData()
  }, [])

  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name
    let value = event.target.value
    setSignupState({ ...signupState, [name]: value })

    name === 'email' && setEmailError(emailValidator(value))
    name === 'password' && setPasswordError(passwordValidator(value))
    name === 'firstName' && setFirstNameError(firstNameValidator(value))
    name === 'lastName' && setLastNameError(lastNameValidator(value))
  }
  const changeRoleHandler = (event: SelectChangeEvent<HTMLInputElement>) => {
    let name = event.target.name
    let value = event.target.value
    setSignupState({ ...signupState, [name]: value })
    if (name === 'role') setRoleError(roleValidator(value.toString()))
    else if (name === 'programOffice')
      setProgramOfficeError(roleValidator(value.toString()))
  }

  const validateSignup = () => {
    let validate = true
    if (emailValidator(signupState.email) !== '') {
      validate = false
      setEmailError(emailValidator(signupState.email))
    }
    if (passwordValidator(signupState.password) !== '') {
      validate = false
      setPasswordError(passwordValidator(signupState.password))
    }
    if (firstNameValidator(signupState.firstName) !== '') {
      validate = false
      setFirstNameError(firstNameValidator(signupState.firstName))
    }
    if (lastNameValidator(signupState.lastName) !== '') {
      validate = false
      setLastNameError(lastNameValidator(signupState.lastName))
    }
    if (roleValidator(signupState.role) !== '') {
      validate = false
      setRoleError(roleValidator(signupState.role))
    }
    if (programOfficeValidator(signupState.programOffice) !== '') {
      validate = false
      setProgramOfficeError(programOfficeValidator(signupState.programOffice))
    }
    return validate
  }

  const signupUser = async () => {
    if (!validateSignup()) {
      return
    }

    if (
      firstNameError === '' &&
      lastNameError === '' &&
      emailError === '' &&
      passwordError === '' &&
      roleError === '' &&
      programOfficeError === ''
    ) {
      try {
        const { data } = await signup(
          signupState.firstName,
          signupState.lastName,
          signupState.email,
          signupState.password,
          signupState.role,
          signupState.programOffice
        )
        if (data) {
          if (data.signup.statusCode === 200) {
            localStorage.setItem('user', JSON.stringify(data.signup.data))
            //updateAuthState(true)
            setRequestReceived(true)
          }
          if (data.signup.statusCode === 404) {
            setEmailError(data.signup.message)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const handleLoginOpen = () => {
    props.handleLoginOpen()
    props.modelClose()
  }

  return (
    <>
      <Box className={classes.boxWrapper} sx={{ flexGrow: 1 }}>
        {!showRequestReceived && (
          <Grid container spacing={2}>
            {!isMobView && (
              <Grid color='info' item sm={12} md={3}>
                <Item
                  style={flexItemCenter}
                  className={classes.heightVh_16px}
                  sx={{
                    bgcolor: 'primary.main',
                    p: 1.6,
                    m: 1.2,
                    mt: { sm: 4, md: 1.2 }
                  }}
                  color='info'
                >
                  <img
                    alt='Logo'
                    style={loginSignupImageStyle}
                    src={logo}
                    width='100%'
                    max-width='224px'
                  />
                </Item>
              </Grid>
            )}
            <Grid item xs={12} md={9} width='100%'>
              <Box>
                <CloseRoundedIcon
                  onClick={props.modelClose}
                  className={classes.closeIcon}
                  sx={{ fontSize: 20, color: '#253D82', fontWeight: 200 }}
                />
              </Box>
              <Box sx={{ p: 2 }}>
                <Item style={flexItemColumn} className={classes.heightVh_16px}>
                  <Typography
                    variant='h6'
                    sx={{ fontWeight: 600 }}
                    align='left'
                    color='primary'
                  >
                    Welcome to the ETA Event Scheduler
                  </Typography>
                  <Typography
                    sx={{ mb: 5 }}
                    variant='body1'
                    align='left'
                    color='primary'
                  >
                    Request your account by signing up below
                  </Typography>
                  <Box className={classes.inputBoxStyle}>
                    <TextField
                      sx={{ width: '100%' }}
                      size='small'
                      className={classNames(classes.root, classes.inputStyle)}
                      required
                      id='outlined-required'
                      label='First Name'
                      type='text'
                      name='firstName'
                      value={signupState.firstName}
                      onChange={changeHandler}
                      InputLabelProps={{ shrink: true }}
                      helperText={firstNameError}
                      error={!!firstNameError}
                      classes={{
                        root: classes.textField
                      }}
                    />
                    <TextField
                      size='small'
                      className={classNames(classes.root, classes.inputStyle)}
                      sx={{ width: '100%' }}
                      required
                      id='outlined-password-input'
                      label='Last Name'
                      type='text'
                      name='lastName'
                      value={signupState.lastName}
                      onChange={changeHandler}
                      InputLabelProps={{ shrink: true }}
                      helperText={lastNameError}
                      error={!!lastNameError}
                      classes={{
                        root: classes.textField
                      }}
                    />
                  </Box>

                  <Box className={classes.inputBoxStyle}>
                    <TextField
                      size='small'
                      className={classNames(classes.root, classes.inputStyle)}
                      sx={{ width: '100%' }}
                      required
                      id='outlined-required'
                      label='Email'
                      type='email'
                      name='email'
                      value={signupState.email}
                      onChange={changeHandler}
                      InputLabelProps={{ shrink: true }}
                      helperText={emailError}
                      error={!!emailError}
                      classes={{
                        root: classes.textField
                      }}
                    />
                    <TextField
                      size='small'
                      className={classNames(classes.root, classes.inputStyle)}
                      sx={{ width: '100%' }}
                      required
                      id='outlined-password-input'
                      label='Password'
                      type='password'
                      name='password'
                      value={signupState.password}
                      onChange={changeHandler}
                      autoComplete='current-password'
                      InputLabelProps={{ shrink: true }}
                      helperText={passwordError}
                      error={!!passwordError}
                      classes={{
                        root: classes.textField
                      }}
                    />
                  </Box>

                  <Box className={classes.inputBoxStyle}>
                    <FormControl
                      fullWidth
                      className={classNames(classes.root, classes.inputStyle)}
                      size='small'
                    >
                      <InputLabel sx={{ fontSize: '14px' }}>Role</InputLabel>
                      <Select
                        required
                        label='Role'
                        name='role'
                        onChange={changeRoleHandler}
                        error={!!roleError}
                        MenuProps={{
                          MenuListProps: {
                            sx: {
                              minWidth: '100%'
                            }
                          }
                        }}
                      >
                        <MenuItem
                          sx={{ fontSize: '14px' }}
                          value={Role.REQUESTER}
                        >
                          Requester
                        </MenuItem>
                        <MenuItem
                          sx={{ fontSize: '14px' }}
                          value={Role.APPROVER}
                        >
                          Approver
                        </MenuItem>
                      </Select>
                      {roleError && (
                        <FormHelperText error>{roleError}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      fullWidth
                      className={classNames(classes.root, classes.inputStyle)}
                      size='small'
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          minHeight: '40px',
                          alignItems: 'flex-start'
                        }
                      }}
                    >
                      <InputLabel sx={{ fontSize: '14px' }}>
                        Program Office
                      </InputLabel>
                      <Select
                        required
                        label='Program Office'
                        name='programOffice'
                        onChange={changeRoleHandler}
                        error={!!programOfficeError}
                        sx={{
                          '& .MuiSelect-select': {
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            overflow: 'visible',
                            minHeight: '1.4375em',
                            height: 'auto',
                            paddingTop: '8.5px',
                            paddingBottom: '8.5px'
                          }
                        }}
                        MenuProps={{
                          MenuListProps: {
                            sx: {
                              minWidth: '100%',
                              maxHeight: 300,
                              overflowY: 'auto'
                            }
                          }
                        }}
                      >
                        {programOfficeData.map(x => (
                          <MenuItem
                            key={x.id}
                            sx={{ fontSize: '14px', whiteSpace: 'pre-wrap' }}
                            value={x.id}
                          >
                            {x.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {programOfficeError && (
                        <FormHelperText error>
                          {programOfficeError}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Box>
                  <Button
                    className={classes.buttonDesing}
                    sx={loginSignupButton}
                    style={{
                      textTransform: 'none',
                      fontSize: 14,
                      fontWeight: 500
                    }}
                    variant='contained'
                    onClick={signupUser}
                  >
                    {' '}
                    Sign up
                  </Button>
                </Item>
              </Box>
              <Grid
                sx={{
                  pb: 2,
                  display: 'flex',
                  flexDirection: {
                    sm: 'column-reverse',
                    md: 'row',
                    xs: 'column-reverse'
                  }
                }}
              >
                <Grid
                  item
                  sm={12}
                  md={12}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Typography sx={{ fontSize: 12, fontWeight: 400 }}>
                    Already have an account?
                  </Typography>
                  <Link
                    href='#'
                    color='secondary'
                    underline='none'
                    onClick={handleLoginOpen}
                    sx={{
                      display: 'inline',
                      ml: 1,
                      fontSize: 12,
                      fontWeight: 600
                    }}
                  >
                    Log in
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        {showRequestReceived && (
          <Box sx={{ width: { sm: 545 }, borderRadius: '12px' }}>
            <CloseRoundedIcon
              className={classes.closeIcon}
              sx={{ fontSize: 20, color: '#253D82', fontWeight: 200 }}
              onClick={() => {
                props.modelClose()
                window.location.reload()
              }}
            />

            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                ml: 4.5,
                pt: 8,
                pb: 5
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex'
                }}
              >
                <Box
                  component='img'
                  src={SuccessSignupIcon}
                  alt='SuccessSignupIcon'
                />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 500,
                    lineHeight: 1.4,
                    maxWidth: 250,
                    ml: 2
                  }}
                >
                  Great! Your account request will be reviewed shortly.
                </Typography>
              </Box>
              <ButtonCustom
                variant='contained'
                icon={false}
                label='Continue'
                width='334px'
                onClick={() => {
                  props.modelClose()
                  window.location.reload()
                }}
                sx={{ mb: 0, mt: 5 }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </>
  )
}

export default Signup
